import type { RouteRecordRaw } from 'vue-router'
import { prefixRoutes, route } from '@/router/utils'
import type { Options } from '@/router'
import { i18n } from '@/i18n'

import {
  DOCUMENTS_TAB_KEY,
  COMPANIES_TAB_KEY,
  COMPANY_TAB_KEY,
  TEMPLATES_TAB_KEY,
} from './const'
import { receiveRoute } from '@m/cabinet/components/views/utils'
import { companyApi } from '@/services/company.service'
import Receive from '@m/cabinet/components/views/Receive.vue'
import { path } from 'ramda'

const DOCUMENTS_FLOW_PREFIX = 'cabinet:documents-flow'
const p = (name: string) => DOCUMENTS_FLOW_PREFIX + ':' + name

export const DOCUMENTS_FLOW_VIEW_NAME = p('view')
export const DOCUMENTS_FLOW_DOCUMENTS_VIEW_NAME = p(DOCUMENTS_TAB_KEY)
export const DOCUMENTS_FLOW_COMPANIES_VIEW_NAME = p(COMPANIES_TAB_KEY)
export const DOCUMENTS_FLOW_COMPANY_VIEW_NAME = p(COMPANY_TAB_KEY)
export const DOCUMENTS_FLOW_TEMPLATES_VIEW_NAME = p(TEMPLATES_TAB_KEY)

export const DOCUMENTS_FLOW_COMPANIES_COMPANY_VIEW_NAME = p('company')

const View = () => import('@m/cabinet/modules/DocumentFlow/views/View.vue')
const CompanyForm = () =>
  import('@m/cabinet/modules/DocumentFlow/views/CompanyForm.vue')

const Documents = () =>
  import('@m/cabinet/modules/DocumentFlow/tabs/Documents.vue')
const Companies = () =>
  import('@m/cabinet/modules/DocumentFlow/tabs/Companies.vue')
const Templates = () =>
  import('@m/cabinet/modules/DocumentFlow/tabs/Templates.vue')

const BASE_MODEL_NAME = 'documents-flow/'

export function createRoutes(options: Options): RouteRecordRaw[] {
  const { t: $t } = i18n.global

  return [
    prefixRoutes(
      ':chainId/',
      [
        route('documents/', Documents, DOCUMENTS_FLOW_DOCUMENTS_VIEW_NAME, {
          meta: {
            title: () => $t('Document flow'),
          },
        }),
        route('companies/', Companies, DOCUMENTS_FLOW_COMPANIES_VIEW_NAME, {
          meta: {
            title: () => $t('Companies'),
          },
        }),
        route('templates/', Templates, DOCUMENTS_FLOW_TEMPLATES_VIEW_NAME, {
          meta: {
            title: () => $t('Templates'),
          },
        }),
      ],
      {
        ...options,
        component: View,
        name: DOCUMENTS_FLOW_VIEW_NAME,
        redirect: { name: DOCUMENTS_FLOW_DOCUMENTS_VIEW_NAME },
      }
    ),
    prefixRoutes(
      ':chainId/company',
      [
        receiveRoute(
          companyApi.detail,
          [
            route('', CompanyForm, DOCUMENTS_FLOW_COMPANIES_COMPANY_VIEW_NAME, {
              meta: {
                title: () => '&nbsp;',
                fallbackRouteName: {
                  name: DOCUMENTS_FLOW_COMPANIES_VIEW_NAME,
                  text: $t('Back to the companies list'),
                },
              },
            }),
          ],
          Receive,
          ''
        ),
      ],
    ),
  ]
}

export { BASE_MODEL_NAME }
